var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"ax-help"},[_c('AxTooltip',{attrs:{"title":_vm.content,"arrow":""}},[_c('AxIcon',{attrs:{"tabindex":"0","name":"help"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }